import { ModalService } from './modal.service'
import { eventBus } from '@/src/shared/lib/eventBus'

/**
 * @description A singleton instance of the ModalService class, which implements
 * the IModalPlugin interface. The modal singleton is used to manage modals
 * throughout the application.
 */
export const modal = new ModalService(eventBus)
